import React, { useEffect, useState, useCallback } from "react";

export const ResizableHorizontalDivider = ({
  minSize = 10,
  maxSize = 90,
  onResize,
  onDoubleClick,
}) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    e.preventDefault();
  };

  const handleMouseMove = useCallback((e) => {
    if (isDragging) {
      const containerHeight = window.innerHeight - 24 - 20; // Subtract top and bottom offsets
      const newHeight = ((e.clientY - 24) / containerHeight) * 100;
      onResize(Math.max(minSize, Math.min(maxSize, newHeight)));
    }
  }, [isDragging, onResize, minSize, maxSize]);

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging, handleMouseMove, handleMouseUp]);

  return (
    <div
      className="h-[2px] bg-gray-700 cursor-ns-resize"
      onMouseDown={handleMouseDown}
      onDoubleClick={onDoubleClick}
    />
  );
};